import { createAsyncThunk } from '@reduxjs/toolkit';
import { locationsClient } from 'api/clients';
import {
  addLocationSuccess,
  fetchLocationsSuccess,
  requestFailure,
  requestStart
} from './locationsSlice';

// Fetch all locations
export const fetchAllLocationsThunk = createAsyncThunk(
  'locations/fetchAllLocations',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const locations = await locationsClient.getLocations();
      dispatch(fetchLocationsSuccess(locations));
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);

// Add new location
export const addNewLocationThunk = createAsyncThunk(
  'locations/addNewLocation',
  async (formData, { dispatch }) => {
    dispatch(requestStart());
    try {
      const payload = {
        name: formData.locationName,
        electricityBuyingPrice: parseFloat(formData.buyingPrice)
      };

      const newLocation = await locationsClient.addLocation(payload);
      dispatch(addLocationSuccess(newLocation));

      return newLocation;
    } catch (error) {
      dispatch(requestFailure(error.toString()));
      throw error;
    }
  }
);
